function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { uniq } from 'lodash';
import { All } from '..'; // 平铺树结构，方便根据 value（字符串） 获取到所有的 NodeItem 节点
// 添加 parent 链接到父节点

export function flattenTree(root) {
  var res = [];

  function dfs(nodes) {
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (!nodes) {
      return;
    }

    var newChildren = [];

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var children = node.children;

      var newNode = _objectSpread(_objectSpread({}, node), {}, {
        parent: parent
      });

      res.push(newNode);
      newChildren.push(newNode);

      if (children) {
        dfs(children, newNode);
      }
    }

    if (parent) {
      // eslint-disable-next-line no-param-reassign
      parent.children = newChildren;
    }
  }

  dfs(root);
  return res;
} // 是否有子节点（包括自己）被选中

export function hasChildChecked(item, curValue) {
  function dfs(node) {
    if (!node) {
      return false;
    }

    var value = node.value,
        children = node.children;

    if (curValue.includes(value)) {
      return true;
    }

    if (!children) {
      return false;
    }

    return children.some(function (child) {
      return dfs(child);
    });
  }

  return dfs(item);
} // 是否有父节点（包括自己）被选中

export function hasParentChecked(item, value) {
  var tmp = item;

  while (tmp) {
    if (value.includes(tmp.value)) {
      return true;
    }

    tmp = tmp.parent;
  }

  return false;
}
export function matchAllLeafValue() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var roots = arguments.length > 1 ? arguments[1] : undefined;
  var res = [];

  function dfs(nodes, needed) {
    if (!nodes) {
      return;
    }

    nodes.forEach(function (node) {
      var nodeValue = node.value,
          children = node.children;

      if (needed || value.includes(nodeValue)) {
        if (!children) {
          // 叶子节点
          res.push(nodeValue);
        } else {
          dfs(children, true);
        }
      } else {
        dfs(children, needed);
      }
    });
  }

  dfs(roots, false);
  return uniq(res);
} // 匹配所有叶子节点的路径

export function matchAllLeafValueWithPath(params) {
  var res = [];
  var value = params.value,
      treeData = params.treeData,
      paths = params.paths;

  function dfs(nodes, needed, depth, parentVal) {
    if (!nodes) {
      return;
    }

    nodes.forEach(function (node) {
      var nodeValue = node.value,
          children = node.children;

      if (needed || value.includes(nodeValue)) {
        if (!children) {
          var pathValue = parentVal.concat(nodeValue); // 叶子节点

          res.push(paths.reduce(function (cur, next, index) {
            return _objectSpread(_objectSpread({}, cur), {}, _defineProperty({}, next, pathValue[index]));
          }, {}));
        } else {
          dfs(children, true, depth + 1, parentVal.concat(nodeValue));
        }
      } else {
        dfs(children, needed, depth + 1, parentVal.concat(nodeValue));
      }
    });
  }

  dfs(treeData, false, 0, []);
  return res;
} // 删除所有子孙节点的 value, 不包括自己
// 输入可能是 dirty

export function removeAllDescendanceValue(root, value) {
  var allChildrenValue = [];

  function dfs(node) {
    if (node.children) {
      node.children.forEach(function (item) {
        allChildrenValue.push(item.value);
        dfs(item);
      });
    }
  }

  dfs(root);
  return value.filter(function (val) {
    return !allChildrenValue.includes(val);
  });
} // 状态提升

export function liftTreeState(item, curVal) {
  var value = item.value; // 加入当前节点 value

  var nextValue = curVal.concat(value);
  var last = item; // eslint-disable-next-line no-constant-condition

  while (true) {
    var _last, _last$parent;

    // 如果父节点的所有子节点都已经 checked, 添加该节点 value，继续尝试提升
    if ((_last = last) === null || _last === void 0 ? void 0 : (_last$parent = _last.parent) === null || _last$parent === void 0 ? void 0 : _last$parent.children.every(function (child) {
      return nextValue.includes(child.value);
    })) {
      nextValue.push(last.parent.value);
      last = last.parent;
    } else {
      break;
    }
  } // 移除最后一个满足 checked 的父节点的所有子孙节点 value


  return removeAllDescendanceValue(last, nextValue);
} // 不状态提升

export function noLiftTreeState(item, curVal) {
  var value = item.value; // 加入当前节点 value

  return curVal.concat(value);
} // 状态下沉

export function sinkTreeState(root, value) {
  var parentValues = [];
  var subTreeValues = [];

  function getCheckedParent(node) {
    if (!node) {
      return null;
    }

    parentValues.push(node.value);

    if (value.includes(node.value)) {
      return node;
    }

    return getCheckedParent(node.parent);
  }

  var checkedParent = getCheckedParent(root);

  if (!checkedParent) {
    return value;
  }

  function dfs(node) {
    if (!node.children || node.value === root.value) {
      return;
    }

    node.children.forEach(function (item) {
      if (item.value !== root.value) {
        if (parentValues.includes(item.value)) {
          dfs(item);
        } else {
          subTreeValues.push(item.value);
        }
      }
    });
  }

  dfs(checkedParent); // 替换 checkedParent 下子树的值

  var nextValue = removeAllDescendanceValue(checkedParent, value).filter(function (item) {
    return item !== checkedParent.value;
  });
  return uniq(nextValue.concat(subTreeValues));
} // checked, unchecked 时重新计算

export function reconcile(item, checked, value) {
  var isLiftTree = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (checked) {
    // 如果已经有父节点被 checked, 再进行 checked 没有意义，直接忽略
    // 主要是用在避免初始化时传入的 value 结构不合理
    if (hasParentChecked(item, value)) {
      return value;
    }

    return isLiftTree ? liftTreeState(item, value) : noLiftTreeState(item, value);
  }

  return sinkTreeState(item, value);
} // 按树的 dfs 前序排

export function sortByTree(value, flattenData) {
  var map = {}; // 按照树结构前顺排序

  flattenData.forEach(function (node, index) {
    map[node.value] = index;
  });
  return value.sort(function (a, b) {
    return map[a] - map[b] || 0;
  });
} // 过滤非法数据，排序

export function transformValue(value, flattenData) {
  var isLiftTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var nextValue = [];

  if (value.some(function (v) {
    return v === All;
  })) {
    return [All];
  }

  var _loop = function _loop(i) {
    var node = flattenData.find(function (item) {
      return item.value === value[i];
    });

    if (node) {
      nextValue = reconcile(node, true, nextValue, isLiftTree);
    } else {
      nextValue.push(value[i]);
    }
  };

  for (var i = 0; i < value.length; i++) {
    _loop(i);
  }

  return sortByTree(nextValue, flattenData);
} // 通过 value 查找树节点

export function findNodeByValue(value, tree) {
  function findParent(nodes) {
    if (!nodes) {
      return undefined;
    }

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];

      if (value === node.value) {
        return node;
      }

      if (node.children) {
        var foundInChildren = findParent(node.children);

        if (foundInChildren) {
          return foundInChildren;
        }
      }
    }

    return undefined;
  }

  return findParent(tree);
}